import { cn } from '@utils/cn';

import COLORS from '@ui-component-library/styles/colors';

import { legacyVariantElements } from './_deprecated/old-typography';

import type { TextProps, TextVariant } from './Text.types';

import { textVariants } from './Text.styles';

const elementMap: Record<TextVariant, React.ElementType> = {
  // Legacy variants (deprecated)
  ...(legacyVariantElements as Record<TextVariant, React.ElementType>),
  // New Typography Variants
  // Text 2xs variants (smallest) - typically for captions, labels
  'text-2xs/leading-none/black': 'span',
  'text-2xs/leading-none/bold': 'span',
  'text-2xs/leading-none/extrabold': 'span',
  'text-2xs/leading-none/extralight': 'span',
  'text-2xs/leading-none/italic': 'span',
  'text-2xs/leading-none/light': 'span',
  'text-2xs/leading-none/medium': 'span',
  'text-2xs/leading-none/normal': 'span',
  'text-2xs/leading-none/semibold': 'span',
  'text-2xs/leading-none/strikethrough': 'span',
  'text-2xs/leading-none/thin': 'span',
  'text-2xs/leading-none/underlined': 'span',
  'text-2xs/leading-normal/black': 'span',
  'text-2xs/leading-normal/bold': 'span',
  'text-2xs/leading-normal/extrabold': 'span',
  'text-2xs/leading-normal/extralight': 'span',
  'text-2xs/leading-normal/italic': 'span',
  'text-2xs/leading-normal/light': 'span',
  'text-2xs/leading-normal/medium': 'span',
  'text-2xs/leading-normal/normal': 'span',
  'text-2xs/leading-normal/semibold': 'span',
  'text-2xs/leading-normal/strikethrough': 'span',
  'text-2xs/leading-normal/thin': 'span',
  'text-2xs/leading-normal/underlined': 'span',

  // Text xs variants - small text, captions
  'text-xs/leading-none/black': 'span',
  'text-xs/leading-none/bold': 'span',
  'text-xs/leading-none/extrabold': 'span',
  'text-xs/leading-none/extralight': 'span',
  'text-xs/leading-none/italic': 'span',
  'text-xs/leading-none/light': 'span',
  'text-xs/leading-none/medium': 'span',
  'text-xs/leading-none/normal': 'span',
  'text-xs/leading-none/semibold': 'span',
  'text-xs/leading-none/strikethrough': 'span',
  'text-xs/leading-none/thin': 'span',
  'text-xs/leading-none/underlined': 'span',
  'text-xs/leading-normal/black': 'span',
  'text-xs/leading-normal/bold': 'span',
  'text-xs/leading-normal/extrabold': 'span',
  'text-xs/leading-normal/extralight': 'span',
  'text-xs/leading-normal/italic': 'span',
  'text-xs/leading-normal/light': 'span',
  'text-xs/leading-normal/medium': 'span',
  'text-xs/leading-normal/normal': 'span',
  'text-xs/leading-normal/semibold': 'span',
  'text-xs/leading-normal/strikethrough': 'span',
  'text-xs/leading-normal/thin': 'span',
  'text-xs/leading-normal/underlined': 'span',

  // Text sm variants - small body text
  'text-sm/leading-none/black': 'p',
  'text-sm/leading-none/bold': 'p',
  'text-sm/leading-none/extrabold': 'p',
  'text-sm/leading-none/extralight': 'p',
  'text-sm/leading-none/italic': 'p',
  'text-sm/leading-none/light': 'p',
  'text-sm/leading-none/medium': 'p',
  'text-sm/leading-none/normal': 'p',
  'text-sm/leading-none/semibold': 'p',
  'text-sm/leading-none/strikethrough': 'p',
  'text-sm/leading-none/thin': 'p',
  'text-sm/leading-none/underlined': 'p',
  'text-sm/leading-normal/black': 'p',
  'text-sm/leading-normal/bold': 'p',
  'text-sm/leading-normal/extrabold': 'p',
  'text-sm/leading-normal/extralight': 'p',
  'text-sm/leading-normal/italic': 'p',
  'text-sm/leading-normal/light': 'p',
  'text-sm/leading-normal/medium': 'p',
  'text-sm/leading-normal/normal': 'p',
  'text-sm/leading-normal/semibold': 'p',
  'text-sm/leading-normal/strikethrough': 'p',
  'text-sm/leading-normal/thin': 'p',
  'text-sm/leading-normal/underlined': 'p',
  'text/sm/leading/normal/underlined/(medium)': 'p',

  // Text base variants - standard body text
  'text-base/leading-none/black': 'p',
  'text-base/leading-none/bold': 'p',
  'text-base/leading-none/extrabold': 'p',
  'text-base/leading-none/extralight': 'p',
  'text-base/leading-none/italic': 'p',
  'text-base/leading-none/light': 'p',
  'text-base/leading-none/medium': 'p',
  'text-base/leading-none/normal': 'p',
  'text-base/leading-none/semibold': 'p',
  'text-base/leading-none/strikethrough': 'p',
  'text-base/leading-none/thin': 'p',
  'text-base/leading-none/underlined': 'p',
  'text-base/leading-normal/black': 'p',
  'text-base/leading-normal/bold': 'p',
  'text-base/leading-normal/extrabold': 'p',
  'text-base/leading-normal/extralight': 'p',
  'text-base/leading-normal/italic': 'p',
  'text-base/leading-normal/light': 'p',
  'text-base/leading-normal/medium': 'p',
  'text-base/leading-normal/normal': 'p',
  'text-base/leading-normal/semibold': 'p',
  'text-base/leading-normal/strikethrough': 'p',
  'text-base/leading-normal/thin': 'p',
  'text-base/leading-normal/underlined': 'p',
  'text/base/leading/normal/underlined/(medium)': 'p',

  // Text lg variants - large body text
  'text-lg/leading-none/black': 'p',
  'text-lg/leading-none/bold': 'p',
  'text-lg/leading-none/extrabold': 'p',
  'text-lg/leading-none/extralight': 'p',
  'text-lg/leading-none/italic': 'p',
  'text-lg/leading-none/light': 'p',
  'text-lg/leading-none/medium': 'p',
  'text-lg/leading-none/normal': 'p',
  'text-lg/leading-none/semibold': 'p',
  'text-lg/leading-none/strikethrough': 'p',
  'text-lg/leading-none/thin': 'p',
  'text-lg/leading-none/underlined': 'p',
  'text-lg/leading-normal/black': 'p',
  'text-lg/leading-normal/bold': 'p',
  'text-lg/leading-normal/extrabold': 'p',
  'text-lg/leading-normal/extralight': 'p',
  'text-lg/leading-normal/italic': 'p',
  'text-lg/leading-normal/light': 'p',
  'text-lg/leading-normal/medium': 'p',
  'text-lg/leading-normal/normal': 'p',
  'text-lg/leading-normal/semibold': 'p',
  'text-lg/leading-normal/strikethrough': 'p',
  'text-lg/leading-normal/thin': 'p',
  'text-lg/leading-normal/underlined': 'p',

  // Text xl variants - extra large text, subheadings
  'text-xl/leading-none/black': 'h4',
  'text-xl/leading-none/bold': 'h4',
  'text-xl/leading-none/extrabold': 'h4',
  'text-xl/leading-none/extralight': 'h4',
  'text-xl/leading-none/italic': 'h4',
  'text-xl/leading-none/light': 'h4',
  'text-xl/leading-none/medium': 'h4',
  'text-xl/leading-none/normal': 'h4',
  'text-xl/leading-none/semibold': 'h4',
  'text-xl/leading-none/strikethrough': 'h4',
  'text-xl/leading-none/thin': 'h4',
  'text-xl/leading-none/underlined': 'h4',
  'text-xl/leading-normal/black': 'h4',
  'text-xl/leading-normal/bold': 'h4',
  'text-xl/leading-normal/extrabold': 'h4',
  'text-xl/leading-normal/extralight': 'h4',
  'text-xl/leading-normal/italic': 'h4',
  'text-xl/leading-normal/light': 'h4',
  'text-xl/leading-normal/medium': 'h4',
  'text-xl/leading-normal/normal': 'h4',
  'text-xl/leading-normal/semibold': 'h4',
  'text-xl/leading-normal/strikethrough': 'h4',
  'text-xl/leading-normal/thin': 'h4',
  'text-xl/leading-normal/underlined': 'h4',

  // Text 2xl variants - large headings
  'text-2xl/leading-none/black': 'h3',
  'text-2xl/leading-none/bold': 'h3',
  'text-2xl/leading-none/extrabold': 'h3',
  'text-2xl/leading-none/extralight': 'h3',
  'text-2xl/leading-none/italic': 'h3',
  'text-2xl/leading-none/light': 'h3',
  'text-2xl/leading-none/medium': 'h3',
  'text-2xl/leading-none/normal': 'h3',
  'text-2xl/leading-none/semibold': 'h3',
  'text-2xl/leading-none/strikethrough': 'h3',
  'text-2xl/leading-none/thin': 'h3',
  'text-2xl/leading-none/underlined': 'h3',
  'text-2xl/leading-normal/black': 'h3',
  'text-2xl/leading-normal/bold': 'h3',
  'text-2xl/leading-normal/extrabold': 'h3',
  'text-2xl/leading-normal/extralight': 'h3',
  'text-2xl/leading-normal/italic': 'h3',
  'text-2xl/leading-normal/light': 'h3',
  'text-2xl/leading-normal/medium': 'h3',
  'text-2xl/leading-normal/normal': 'h3',
  'text-2xl/leading-normal/semibold': 'h3',
  'text-2xl/leading-normal/strikethrough': 'h3',
  'text-2xl/leading-normal/thin': 'h3',
  'text-2xl/leading-normal/underlined': 'h3',

  // Text 3xl variants - larger headings
  'text-3xl/leading-none/black': 'h2',
  'text-3xl/leading-none/bold': 'h2',
  'text-3xl/leading-none/extrabold': 'h2',
  'text-3xl/leading-none/extralight': 'h2',
  'text-3xl/leading-none/italic': 'h2',
  'text-3xl/leading-none/light': 'h2',
  'text-3xl/leading-none/medium': 'h2',
  'text-3xl/leading-none/normal': 'h2',
  'text-3xl/leading-none/semibold': 'h2',
  'text-3xl/leading-none/strikethrough': 'h2',
  'text-3xl/leading-none/thin': 'h2',
  'text-3xl/leading-none/underlined': 'h2',
  'text-3xl/leading-normal/black': 'h2',
  'text-3xl/leading-normal/bold': 'h2',
  'text-3xl/leading-normal/extrabold': 'h2',
  'text-3xl/leading-normal/extralight': 'h2',
  'text-3xl/leading-normal/italic': 'h2',
  'text-3xl/leading-normal/light': 'h2',
  'text-3xl/leading-normal/medium': 'h2',
  'text-3xl/leading-normal/normal': 'h2',
  'text-3xl/leading-normal/semibold': 'h2',
  'text-3xl/leading-normal/strikethrough': 'h2',
  'text-3xl/leading-normal/thin': 'h2',
  'text-3xl/leading-normal/underlined': 'h2',

  // Text 4xl variants - very large headings
  'text-4xl/leading-none/black': 'h1',
  'text-4xl/leading-none/bold': 'h1',
  'text-4xl/leading-none/extrabold': 'h1',
  'text-4xl/leading-none/extralight': 'h1',
  'text-4xl/leading-none/italic': 'h1',
  'text-4xl/leading-none/light': 'h1',
  'text-4xl/leading-none/medium': 'h1',
  'text-4xl/leading-none/normal': 'h1',
  'text-4xl/leading-none/semibold': 'h1',
  'text-4xl/leading-none/strikethrough': 'h1',
  'text-4xl/leading-none/thin': 'h1',
  'text-4xl/leading-none/underlined': 'h1',
  'text-4xl/leading-normal/black': 'h1',
  'text-4xl/leading-normal/bold': 'h1',
  'text-4xl/leading-normal/extrabold': 'h1',
  'text-4xl/leading-normal/extralight': 'h1',
  'text-4xl/leading-normal/italic': 'h1',
  'text-4xl/leading-normal/light': 'h1',
  'text-4xl/leading-normal/medium': 'h1',
  'text-4xl/leading-normal/normal': 'h1',
  'text-4xl/leading-normal/semibold': 'h1',
  'text-4xl/leading-normal/strikethrough': 'h1',
  'text-4xl/leading-normal/thin': 'h1',
  'text-4xl/leading-normal/underlined': 'h1',

  // Text 5xl variants - display headings
  'text-5xl/leading-none/black': 'h1',
  'text-5xl/leading-none/bold': 'h1',
  'text-5xl/leading-none/extrabold': 'h1',
  'text-5xl/leading-none/extralight': 'h1',
  'text-5xl/leading-none/italic': 'h1',
  'text-5xl/leading-none/light': 'h1',
  'text-5xl/leading-none/medium': 'h1',
  'text-5xl/leading-none/normal': 'h1',
  'text-5xl/leading-none/semibold': 'h1',
  'text-5xl/leading-none/strikethrough': 'h1',
  'text-5xl/leading-none/thin': 'h1',
  'text-5xl/leading-none/underlined': 'h1',
  'text-5xl/leading-normal/black': 'h1',
  'text-5xl/leading-normal/bold': 'h1',
  'text-5xl/leading-normal/extrabold': 'h1',
  'text-5xl/leading-normal/extralight': 'h1',
  'text-5xl/leading-normal/italic': 'h1',
  'text-5xl/leading-normal/light': 'h1',
  'text-5xl/leading-normal/medium': 'h1',
  'text-5xl/leading-normal/normal': 'h1',
  'text-5xl/leading-normal/semibold': 'h1',
  'text-5xl/leading-normal/strikethrough': 'h1',
  'text-5xl/leading-normal/thin': 'h1',
  'text-5xl/leading-normal/underlined': 'h1',

  // Text 6xl variants - display headings
  'text-6xl/leading-none/black': 'h1',
  'text-6xl/leading-none/bold': 'h1',
  'text-6xl/leading-none/extrabold': 'h1',
  'text-6xl/leading-none/extralight': 'h1',
  'text-6xl/leading-none/light': 'h1',
  'text-6xl/leading-none/medium': 'h1',
  'text-6xl/leading-none/normal': 'h1',
  'text-6xl/leading-none/semibold': 'h1',
  'text-6xl/leading-none/strikethrough': 'h1',
  'text-6xl/leading-none/thin': 'h1',
  'text-6xl/leading-none/untitled': 'h1',
  'text-6xl/leading-normal/black': 'h1',
  'text-6xl/leading-normal/bold': 'h1',
  'text-6xl/leading-normal/extrabold': 'h1',
  'text-6xl/leading-normal/extralight': 'h1',
  'text-6xl/leading-normal/light': 'h1',
  'text-6xl/leading-normal/medium': 'h1',
  'text-6xl/leading-normal/normal': 'h1',
  'text-6xl/leading-normal/semibold': 'h1',
  'text-6xl/leading-normal/strikethrough': 'h1',
  'text-6xl/leading-normal/thin': 'h1',
  'text-6xl/leading-normal/underlined': 'h1',

  // Text 7xl variants - display headings
  'text-7xl/leading-none/black': 'h1',
  'text-7xl/leading-none/bold': 'h1',
  'text-7xl/leading-none/extrabold': 'h1',
  'text-7xl/leading-none/extralight': 'h1',
  'text-7xl/leading-none/light': 'h1',
  'text-7xl/leading-none/medium': 'h1',
  'text-7xl/leading-none/normal': 'h1',
  'text-7xl/leading-none/semibold': 'h1',
  'text-7xl/leading-none/strikethrough': 'h1',
  'text-7xl/leading-none/thin': 'h1',
  'text-7xl/leading-none/untitled': 'h1',
  'text-7xl/leading-normal/black': 'h1',
  'text-7xl/leading-normal/bold': 'h1',
  'text-7xl/leading-normal/extrabold': 'h1',
  'text-7xl/leading-normal/extralight': 'h1',
  'text-7xl/leading-normal/light': 'h1',
  'text-7xl/leading-normal/medium': 'h1',
  'text-7xl/leading-normal/normal': 'h1',
  'text-7xl/leading-normal/semibold': 'h1',
  'text-7xl/leading-normal/strikethrough': 'h1',
  'text-7xl/leading-normal/thin': 'h1',
  'text-7xl/leading-normal/underlined': 'h1',

  // Text 8xl variants - display headings
  'text-8xl/leading-none/black': 'h1',
  'text-8xl/leading-none/bold': 'h1',
  'text-8xl/leading-none/extrabold': 'h1',
  'text-8xl/leading-none/extralight': 'h1',
  'text-8xl/leading-none/light': 'h1',
  'text-8xl/leading-none/medium': 'h1',
  'text-8xl/leading-none/normal': 'h1',
  'text-8xl/leading-none/semibold': 'h1',
  'text-8xl/leading-none/strikethrough': 'h1',
  'text-8xl/leading-none/thin': 'h1',
  'text-8xl/leading-none/underlined': 'h1',
  'text-8xl/leading-normal/black': 'h1',
  'text-8xl/leading-normal/bold': 'h1',
  'text-8xl/leading-normal/extrabold': 'h1',
  'text-8xl/leading-normal/extralight': 'h1',
  'text-8xl/leading-normal/light': 'h1',
  'text-8xl/leading-normal/medium': 'h1',
  'text-8xl/leading-normal/normal': 'h1',
  'text-8xl/leading-normal/semibold': 'h1',
  'text-8xl/leading-normal/strikethrough': 'h1',
  'text-8xl/leading-normal/thin': 'h1',
  'text-8xl/leading-normal/underlined': 'h1',

  // Text 9xl variants (largest) - display headings
  'text-9xl/leading-none/black': 'h1',
  'text-9xl/leading-none/bold': 'h1',
  'text-9xl/leading-none/extrabold': 'h1',
  'text-9xl/leading-none/extralight': 'h1',
  'text-9xl/leading-none/light': 'h1',
  'text-9xl/leading-none/medium': 'h1',
  'text-9xl/leading-none/normal': 'h1',
  'text-9xl/leading-none/semibold': 'h1',
  'text-9xl/leading-none/strikethrough': 'h1',
  'text-9xl/leading-none/thin': 'h1',
  'text-9xl/leading-none/underlined': 'h1',
  'text-9xl/leading-normal/black': 'h1',
  'text-9xl/leading-normal/bold': 'h1',
  'text-9xl/leading-normal/extrabold': 'h1',
  'text-9xl/leading-normal/extralight': 'h1',
  'text-9xl/leading-normal/light': 'h1',
  'text-9xl/leading-normal/medium': 'h1',
  'text-9xl/leading-normal/normal': 'h1',
  'text-9xl/leading-normal/semibold': 'h1',
  'text-9xl/leading-normal/strikethrough': 'h1',
  'text-9xl/leading-normal/thin': 'h1',
  'text-9xl/leading-normal/underlined': 'h1',

  // Title variants
  'title-lg/leading-8/medium': 'h2',
  'title-md/leading-7/medium': 'h3'
} as const;

export function Text({
  variant,
  children,
  className,
  as,
  htmlFor,
  color,
  ...props
}: TextProps & { className?: string; as?: React.ElementType }) {
  if (!children) {
    return null;
  }

  if (Object.keys(legacyVariantElements).includes(variant)) {
    console.warn(
      `The "${variant}" variant is deprecated for text "${children}". Please use the new typography variants instead.`
    );
  }

  let Element = as || elementMap[variant];

  if (!Element) {
    console.error(
      `Invalid Text variant "${variant}" provided for content: "${children}". Falling back to the default "p" element with no styles.`
    );
    Element = 'p';
  }

  if (Element === 'label' && !htmlFor) {
    throw new Error('Label elements must have a "htmlFor" attribute');
  }

  if (color) {
    console.error(
      `The "color" prop for Text with content "${children}" is deprecated. Please use the className prop with "text-${color}" instead.`
    );
  }

  return (
    <Element
      className={cn(textVariants({ variant }), className)}
      htmlFor={htmlFor}
      style={{ color: COLORS[color as keyof typeof COLORS] }}
      {...props}
    >
      {children}
    </Element>
  );
}
